<template>
  <div class="menu">
    <div>
      <div class="logo">
        <router-link to="/"><img :src="require(`@/assets/logo/logo-todomath-for-web-${lang}.png`)"/></router-link>
      </div>
      <div class="item">
        <router-link to="/features" v-html="l10.All_Head_Tapbutton1"></router-link>
      </div>
      <div class="item">
        <router-link to="/curriculum" v-html="l10.All_Head_Tapbutton2"></router-link>
      </div>
      <div v-if="lang == 'en' || lang=='ko'" class="item">
        <router-link to="/educators" v-html="l10.All_Head_Tapbutton3"></router-link>
      </div>
      <div class="item">
        <router-link to="/help" v-html="l10.All_Footer_Menubutton_Buttonname5"></router-link>
      </div>
    </div>
    <div>
      <div v-if="lang == 'en' || lang == 'ko'"  class="classroom">
        <a href="https://secure.todomath.com/classroom/signin" target="_blank"><img class="account-icon" src="@/assets/menubar/icon-classroom.svg"/> &nbsp;<span  v-html="l10.All_Head_Tapbutton6">Classroom</span></a>
      </div>
    </div>
  </div>
</template>

<script>
import L10N from '../../text/common/header.js'
export default {
  name: 'Header',
  data () {
	  var setL10n = L10N[this.$store.state.lang];

    return {
      lang:this.$store.state.lang,
	  l10:setL10n
    }
  },
  methods: {
    onClick(to) {
      if (to == window.location.pathname) return
      this.$router.push(to + window.location.search)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.menu{
  width:1024px;
  margin: 0 auto;
  position: relative;
  height:100px;
  display: flex;
  justify-content: space-between;

}

.menu>div{
  display: flex;
  align-items: center;
}
.menu>div>div.logo{
  width: 79px;
  margin-left: 11px;
}

.menu>div>div.logo img{
  width: 100%;
}
.menu>div>div.item {
  margin-left: 64px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #41403e;
  text-align: center;
}

.menu>div>div:last-of-type{
  margin-right:11px;
}
.menu .account-icon{
  transform: translateY(5.5px);
}
.classroom{
  transform: translateY(-2px);
}
a.router-link-exact-active, a.router-link-active{
	font-weight: bold;
	color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar/LaptopLayout.vue